import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { colors } from 'chime-ui/system';

export const RewardsOrderedList = ({ children }) => {
  return (
    <RewardsOrderedListWrapper>
      {React.Children.map(children, (child, i) => {
        return (
          <>
            <GreenBullet>{i + 1}</GreenBullet>
            {child}
          </>
        );
      })}
    </RewardsOrderedListWrapper>
  );
};

RewardsOrderedList.propTypes = {
  children: PropTypes.node,
};

const GreenBullet = styled.div`
  width: 1.125rem;
  height: 1.125rem;
  padding: 4px;
  text-align: center;
  font-size: 12px;
  background: ${colors.util.logoBrandColor};
  color: ${colors.white};
  border-radius: 50%;
`;

const RewardsOrderedListWrapper = styled.div`
  width: 100%;
  display: grid;
  column-gap: 0.75rem;
  row-gap: 1rem;
  grid-template-columns: auto 1fr;
`;

export const RewardsOrderedListText = styled.p`
  font-size: 16px;
  line-height: 1.5rem;
  margin: -3px 0 0;
`;
